// 
import WebComponent from '../src/webComponents/WebComponent';
import litepicker from 'litepicker';
import dateFormat from 'date-fns/format';
import dateParse from 'date-fns/parse';
import $ from 'jquery';

export default class RangeDatepicker extends WebComponent {
  constructor(props) {
    super(props);
    this.date1 = null;
    this.date2 = null;
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleCancel = this.handleCancel.bind(this);
    this.handleKeyup = this.handleKeyup.bind(this);
  }
  didMount() {
    const {
      language,
      country,
      format,
      targetFrom,
      targetTo,
      directInputExtension,
      partialUpdate,
      partialUpdateTarget,
    } = this.props;

    this.targetInputFrom = document.querySelector('#' + targetFrom);
    this.targetInputTo = document.querySelector('#' + targetTo);

    this.targetInputFrom.setAttribute('data-partial-update', partialUpdate);
    this.targetInputFrom.setAttribute('data-partial-update-target', partialUpdateTarget);
    this.targetInputTo.setAttribute('data-partial-update', partialUpdate);
    this.targetInputTo.setAttribute('data-partial-update-target', partialUpdateTarget);

    this.litepicker = new litepicker({
      element: this.element,
      lang: `${language}-${country}`,
      format: format.toUpperCase(),
      numberOfMonths: 2,
      numberOfColumns: 2,
      singleMode: false,
      showTooltip: false,
      mobileFriendly: true,
      onSelect: (date1, date2) => {
        const thisValue = this.element.value.split(' - ');

        if (thisValue.length == 2) {
          this.updateTargetInputs(thisValue[0] + ' 00:00:00', thisValue[1] + ' 23:59:59', date1, date2);
        }
      },
      onRender: () => {
        if (directInputExtension) {
          this.directInputExtension();
        }
      },
    });

    this.on('keyup', this.handleKeyup);
  }

  directInputExtension() {
    const target = document.querySelector('.litepicker .container__months');

    if (target) {
      const startDate = this.date1;
      const endDate = this.date2;

      const child = document.createElement('div');
      child.classList.add('range-datepicker__input-container');

      this.inputFrom = document.createElement('input');
      this.inputFrom.classList.add('range-datepicker__input', 'range-datepicker__input--from', 'form-control');
      this.inputFrom.setAttribute('type', 'input');

      if (startDate) {
        this.inputFrom.value = this.formatDate(startDate);
      }

      const separator = document.createElement('span');
      separator.classList.add('range-datepicker__sep');
      separator.innerHTML = '-';

      this.inputTo = document.createElement('input');
      this.inputTo.classList.add('range-datepicker__input', 'range-datepicker__input--to', 'form-control');
      this.inputTo.setAttribute('type', 'input');

      if (endDate) {
        this.inputTo.value = this.formatDate(endDate);
      }

      const submitButton = document.createElement('button');
      submitButton.innerHTML = this.i18n('btnApply');
      submitButton.classList.add('range-datepicker__submit');
      submitButton.addEventListener('click', this.handleSubmit);

      const cancelButton = document.createElement('button');
      cancelButton.innerHTML = this.i18n('btnCancel');
      cancelButton.classList.add('range-datepicker__cancel');
      cancelButton.addEventListener('click', this.handleCancel);

      target.appendChild(child);
      child.appendChild(this.inputFrom);
      child.appendChild(separator);
      child.appendChild(this.inputTo);
      child.appendChild(submitButton);
      child.appendChild(cancelButton);
    }
  }

  updateTargetInputs(textValue1, textValue2, date1, date2) {
    this.date1 = date1;
    this.date2 = date2;
    this.targetInputFrom.value = textValue1;
    this.targetInputTo.value = textValue2;

    //targetInputFrom.dispatchEvent(new Event('change'));
    $(this.targetInputFrom).trigger('change');
    $(this.targetInputTo).trigger('change');
  }

  applyChanges() {
    this.litepicker.setDateRange(this.date1, this.date2);
    this.litepicker.hide();
  }

  validateInputs() {
    let isValid1 = false;
    let isValid2 = false;

    if (this.inputFrom.value == '' && this.inputTo.value == '') {
      this.handleCancel();
    }
    else {
      if (this.inputFrom.value == '') {
        this.inputFrom.value = this.inputTo.value;
      }
      if (this.inputTo.value == '') {
        this.inputTo.value = this.inputFrom.value;
      }
      isValid1 = this.validateInput(this.inputFrom);
      isValid2 = this.validateInput(this.inputTo);

      if (isValid1 && isValid2) {
        this.validateInputOrder(this.inputFrom, this.inputTo);
        this.applyChanges();
      }
    }
  }

  validateInput(target) {
    let isValid = true;

    target.classList.remove('has--error');
    const result = this.validateDate(target.value);

    if (!result) {
      isValid = false;
      target.classList.add('has--error');
    }

    return isValid;
  }

  validateDate(date) {
    const {
      format,
    } = this.props;
    let result;
    const format2 = format.replace(/ /gi, '');
    let dateToCheck = this.parseDate(date);

    if (dateToCheck.toString() == 'Invalid Date') {
      dateToCheck = dateParse(date.replace(/ /gi, ''), format2, new Date());

      if (dateToCheck.toString() == 'Invalid Date') {
        result = false;
      } else {
        result = this.formatDate(dateToCheck);
      }
    }
    else {
      result = date;
    }

    return result;
  }

  validateInputOrder(target1, target2) {
    const target1Value = target1.value;
    const target2Value = target2.value;
    const date1 = this.parseDate(target1Value);
    const date2 = this.parseDate(target2Value);

    this.date1 = date1;
    this.date2 = date2;

    if (date1 > date2) {
      target1.value = target2Value;
      target2.value = target1Value;
      this.date1 = date2;
      this.date2 = date1;
    }
  }

  formatDate(date) {
    const {
      format,
    } = this.props;
    return dateFormat(date, format);
  }

  parseDate(date) {
    const {
      format,
    } = this.props;
    return dateParse(date, format, new Date());
  }

  handleSubmit() {
    this.validateInputs();
  }

  handleCancel() {
    this.litepicker.clearSelection();
    this.updateTargetInputs('', '', null, null);
    this.litepicker.hide();
  }

  handleKeyup(e) {
    const {
      format,
    } = this.props;
    let isValid1 = false;
    let isValid2 = false;

    if (e.keyCode == 13) {
      const thisValue = this.element.value.split(' - ');
      if (this.element.value == '') {
        this.handleCancel();
      }
      else {
        if (thisValue.length == 1) {
          isValid1 = this.validateDate(thisValue[0]);
          if (isValid1) {
            this.inputFrom.value = isValid1;
            this.inputTo.value = isValid1;
            this.handleSubmit();
          }
        }
        else {
          isValid1 = this.validateDate(thisValue[0]);
          isValid2 = this.validateDate(thisValue[1]);
          if (isValid1 && isValid2) {
            this.inputFrom.value = isValid1;
            this.inputTo.value = isValid2;
            this.handleSubmit();
          }
        }

      }
    }
  }

  willUnMount() {
    this.litepicker.destroy();
    this.date1 = null;
    this.date2 = null;
  }
}



// WEBPACK FOOTER //
// ./node_modules/fg-frontend/components/RangeDatepicker.js